import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteVideo, useUpdateVideo, useVideo } from '../../hooks/video'
import { Video } from '../../types'
import VideoForm from '../../components/VideoForm'

export default function VideoEdit() {
  const { id } = useParams()
  const { data: video } = useVideo(Number(id))
  const deleteVideo = useDeleteVideo()
  const updateVideo = useUpdateVideo()
  const [modalRm, modalRmActions] = useModalTrigger<Video>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/video">Video</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {video?.titolo}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(video)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <VideoForm
          video={video}
          save={(video) =>
            updateVideo.mutateAsync(video).then(() =>
              toast.success('Video salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il video {modalRm.value.titolo} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteVideo.isLoading}
            onClick={async () => {
              await deleteVideo.mutateAsync(modalRm.value!.id).then(() => {
              navigate('/video')
              })
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
